<h4 mat-dialog-title><i class="fas fa-plus mr-1"></i> Add License Expiry</h4>

<mat-dialog-content class="mat-typography">
    <div>
        <form class="example-form input-content" [formGroup]="form">
            <mat-form-field class="example-full-width">
                <mat-label>Organization*</mat-label>
                <mat-select formControlName="organizationId">
                    <mat-option *ngFor="let organization of organizationList" [value]="organization.id">
                        {{organization.name}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field class="example-full-width">
                <mat-label>Expiry Date*</mat-label>
                <input matInput [matDatepicker]="picker" formControlName="expiryDate" placeholder="Choose a date">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>

            <mat-form-field class="example-full-width">
                <mat-label>Status*</mat-label>
                <mat-select formControlName="status">
                    <mat-option *ngFor="let option of statusOptions" [value]="option.value">
                        {{ option.label }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </form>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button class="btn btn-success float-right mr-2" type="submit" [disabled]="!form.valid" (click)="addLicenseExpiryData()">
        <i class="fas fa-plus mr-1"></i> Add</button>
    <button class="btn btn-light float-right" aria-label="cancel" (click)="closeDialog()">
        <i class="fas fa-times mr-1"></i> Cancel</button>
</mat-dialog-actions>
